(function () {
    "use strict";

    angular.module("atheer.core").directive("infiniteSelect", infiniteSelect);

    function infiniteSelect($timeout, $document) {
        var directive = {
            restrict: "E",
            link: link,
            scope: {
                items: "=",
                selectedItem: "=",
                loading: "=",
                onSearch: "&",
                onLoadMore: "&",
                itemText: "@",
                placeholder: "@",
                floatingLabel: "@",
            },
            template: '<div class="fp-session-infinite-select-container">' +
                '<md-input-container>' +
                    '<div class="md-input fp-session-infinite-select-input-container">' +
                        '<input type="text" ' +
                            'md-floating-label="{{floatingLabel | translate}}"' +
                            'ng-model="internalSearchText" ' +
                            'ng-model-options="{debounce: 500}"' +
                            'ng-change="onSearchChange()"' +
                            'placeholder="{{placeholder}}"' +
                            'ng-focus="onFocus()">' +
                        '<md-icon ng-mousedown="clearSearch($event)" ng-if="!!internalSearchText || selectedItem" class="fp-session-clear-icon" md-font-icon="zmdi zmdi-close"></md-icon>' +
                    '</div>' +
                '</md-input-container>' +
                '<div ng-show="isOpen" class="fp-session-infinite-select-dropdown">' +
                    '<md-list class="fp-session-infinite-select-list">' +
                        '<md-list-item ng-repeat="item in displayItems track by $index" ' +
                                      'ng-click="selectItem(item)"' +
                                      'ng-class="{\'md-selected fp-session-infinite-select-item-selected\': selectedItem && item.id === selectedItem.id}">' +
                            '<div ng-if="item.is_loading">' +
                                '<md-progress-circular md-mode="indeterminate" md-diameter="20"></md-progress-circular>' +
                            '</div>' +
                            '<span ng-if="!item.is_loading" class="fp-session-infinite-select-item-text"> {{item.name}}</span>' +
                        '</md-list-item>' +
                        '<md-list-item ng-if="loading && items.length === 0">' +
                            '<md-progress-circular md-mode="indeterminate" md-diameter="20"></md-progress-circular>' +
                        '</md-list-item>' +
                        '<md-list-item ng-if="!loading && items.length === 0">' +
                            '<span>No items found</span>' +
                        '</md-list-item>' +
                    '</md-list>' +
                '</div>' +
            '</div>',
        };
        return directive;

        function link(scope, el, attrs) {
            scope.isOpen = false;
            scope.displayItems = scope.items;
            scope.internalSearchText = scope.selectedItem ? scope.selectedItem.name : '';
            scope.onFocus = function () {
                scope.isOpen = true;
                bindScrollEvent();
            };

            scope.clearSearch = function (event) {
                event.preventDefault();
                event.stopPropagation();
                scope.internalSearchText = '';
                scope.selectedItem = null;
                scope.isOpen = false;
            };

            scope.onBlur = function () {
                if(!!scope.internalSearchText) {
                    scope.internalSearchText = '';
                    scope.onSearch({ searchText: '' });
                }
                $timeout(function () {
                    scope.isOpen = false;
                }, 150);
            };

            scope.onSearchChange = function () {
                if (scope.onSearch) {
                    scope.onSearch({ searchText: scope.internalSearchText });
                }
            };

            scope.selectItem = function (item) {
                if (!item.is_loading) {
                    scope.selectedItem = item;
                    scope.internalSearchText = item.name;
                    scope.isOpen = false;
                }
            };

            function bindScrollEvent() {
                var listElement = el.find(".fp-session-infinite-select-list");
                listElement.bind("scroll", function () {
                    if (
                        listElement[0].scrollTop +
                            listElement[0].offsetHeight >=
                        listElement[0].scrollHeight - 10
                    ) {
                        if (scope.onLoadMore && !scope.loading) {
                            scope.onLoadMore();
                        }
                    }
                });
                scope.$on("$destroy", function () {
                    listElement.unbind("scroll");
                });
            }

            scope.$watch("items", function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    scope.displayItems = newVal;
                }
            });
            
            scope.$watch("selectedItem", function (newVal, oldVal) {
                if (newVal !== oldVal && newVal) {
                    scope.internalSearchText = newVal.name;
                }
            });
            
            scope.$watch("loading", function (newVal, oldVal) {
                if (newVal) {
                    scope.displayItems.push({
                        is_loading: true,
                        name: "Loading...",
                    });
                } else {
                    scope.displayItems = scope.displayItems.filter(
                        function(item) {
                            return !item.is_loading;
                        }
                    );
                }
            });
            var onDocumentClick = function (event) {
                if(!!scope.internalSearchText) {
                    if(!scope.selectedItem) {
                        scope.internalSearchText = '';
                        scope.onSearch({ searchText: '' });
                    } else if(scope.internalSearchText !== scope.selectedItem.name) {
                        scope.internalSearchText = scope.selectedItem.name;
                        scope.onSearch({ searchText: '' });
                    }
                }
                if (!el[0].contains(event.target)) {
                    scope.$apply(function () {
                        scope.isOpen = false;
                    });
                }
            };
            angular.element($document[0].body).on("click", onDocumentClick);

            scope.$on("$destroy", function () {
                angular.element($document[0].body).off("click", onDocumentClick);
            });
        }
    }
})();
